module.exports = __webpack_public_path__ + "static/media/downtimes_per_fault.8777d0cf.svg";